import React from 'react';
import { connect } from 'react-redux'
import EditarPermisos from './EditarPermisos';

//Importación de actions.
import {
    getScreenData,
    resetState,
    selectProducto,
    selectCategoria,
    selectPrograma,
    deleteFuncion,
    addFuncion,
    deleteHistorial,
    selectHistorial,
    saveChanges,
    errorSave,
    setRedirectOk,
    hidePopUp
} from '../actions/EditarPermisos';

const mapStateToProps = (state) => {
    return {
        data: state.editarPermisos
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getScreenData: (currentScope) => {
            dispatch(getScreenData(currentScope));
        },
        resetState: () => {
            dispatch(resetState());
        },
        selectProducto: (id) => {
            dispatch(selectProducto(id));
        },
        selectCategoria: (id) => {
            dispatch(selectCategoria(id));
        },
        selectPrograma: (id) => {
            dispatch(selectPrograma(id));
        },
        deleteFuncion: (perfilId, funcion) => {
            dispatch(deleteFuncion(perfilId, funcion));
        },
        addFuncion: (perfilId, funcion) => {
            dispatch(addFuncion(perfilId, funcion));
        },
        deleteHistorial: (historialId) => {
            dispatch(deleteHistorial(historialId));
        },
        selectHistorial: (productoId, categoriaId, programaId) => {
            dispatch(selectHistorial(productoId, categoriaId, programaId));
        },
        saveChanges: () => {
            dispatch(saveChanges());
        },
        errorSave: () => {
            dispatch(errorSave());
        },
        setRedirectOk: () => {
            dispatch(setRedirectOk());
        },
        hidePopUp: () => {
            dispatch(hidePopUp());
        }
    }
}

//Connect entre el componente y las props y actions.
const EditarPermisosContainer = connect(mapStateToProps, mapDispatchToProps)(EditarPermisos);

export default EditarPermisosContainer;